@if (closed && exitOnCompletion) {
<div>Booking complete, you can now close this window.</div>
} @if (!closed && unsuitable) {
<div>
  <div>{{ unsuitableMessage }}</div>
</div>
} @if (!closed && !unsuitable) {
<div>
  <ngx-ui-loader
    [loaderId]="'bookingLoader'"
    [text]="currentLoadingMessage"
  ></ngx-ui-loader>
  <mat-toolbar color="primary">
    @if (!exitOnCompletion) {
    <button (click)="returnToMenu()" mat-icon-button>
      <mat-icon>arrow_back</mat-icon>
    </button>
    }
    <div class="toolbar-content">
      <div class="date-chooser">
        <div class="date-chooser-nav-part">
          <button
            (click)="previousWeek()"
            [disabled]="!isPreviousWeekValid"
            class="date-button"
            color="accent"
            id="ButtonPrevious"
            mat-raised-button
          >
            &lt;
          </button>
          w/c {{ selectedDate | amDateFormat : "DD/MM/YYYY" }}
          <span class="spacer"></span>
          <button
            (click)="nextWeek()"
            class="date-button"
            color="accent"
            mat-raised-button
          >
            &gt;
          </button>
          <span class="spacer"></span>
          <button
            (click)="refreshSlots()"
            class="date-button"
            color="accent"
            mat-raised-button
          >
            Refresh Slots
          </button>
          <br />
        </div>
      </div>
    </div>
    <div class="toolbar-actions">
      <button (click)="openReferralForm()" color="warn" mat-flat-button>
        Refer to Planning Team
      </button>
      @if (floatingBookingEnabled) {
      <button
        (click)="switchToFloatingBooking()"
        color="accent"
        mat-flat-button
      >
        <mat-icon>date_range</mat-icon> Switch to Floating Booking
      </button>
      }
    </div>
  </mat-toolbar>
  <div class="booking-container">
    <div class="booking-sidebar">
      @if (visit) {
      <mat-list>
        <h3 mat-subheader>
          Job Details - <b>{{ visit.job.externalJobReference }}</b>
        </h3>

        <div class="priority-container">
          <div
            [style.background-color]="visit.job.priority.backgroundColor"
            [style.color]="visit.job.priority.foregroundColor"
            class="priority-badge"
          >
            <span class="priority-title">{{
              visit.job.priority.description
            }}</span>
            <span class="priority-due"
              >Due
              {{
                visit.job.planningWindowEnd | amDateFormat : "DD/MM/YYYY HH:mm"
              }}</span
            >
          </div>
        </div>

        @if (visit.job.externalCaseReference) {
        <div class="hazard-case-container">
          <div class="hazard-case-badge">
            <mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas"></mat-icon>
            <span>Hazard Case {{ visit.job.externalCaseReference }}</span>
          </div>
        </div>
        }

        <div class="property-info-container">
          <div
            [class]="
              isOverdue ? 'property-info-badge overdue' : 'property-info-badge'
            "
          >
            <div class="property-info-content">
              <span>Due {{ visit.job.planningWindowEnd | amTimeAgo }}</span>
            </div>
          </div>
        </div>
        <!-- Property details bubble -->
        <div class="property-info-container">
          <div class="property-info-badge">
            <div class="property-info-content">
              <span class="property-ref">{{
                visit.job.externalPropertyReference
              }}</span>
              @if (showPropertyAddress) {
              <div class="property-address" [innerHTML]="propertyAddress"></div>
              }
            </div>
          </div>
        </div>
      </mat-list>
      }
      <mat-divider></mat-divider>
      @if (visit && visit.job) {
      <app-visit-property-list-component
        [propertyId]="visit.job.externalPropertyReference"
        [selectedDate]="selectedDate"
        (hasVisitsBeforeWeek)="onHasVisitsBeforeWeek($event)"
        (hasVisitsAfterWeek)="onHasVisitsAfterWeek($event)"
        (visitsInWeek)="onVisitsInWeek($event)"
      ></app-visit-property-list-component>
      }
    </div>
    <div class="booking-main">
      <!-- Position indicators for other bookings -->
      <div class="booking-indicators">
        @if (hasVisitsBeforeCurrentWeek) {
        <div
          class="navigation-arrow prev-week-arrow"
          matTooltip="There are bookings before this week"
        >
          <mat-icon>arrow_back</mat-icon>
        </div>
        } @if (hasVisitsAfterCurrentWeek) {
        <div
          class="navigation-arrow next-week-arrow"
          matTooltip="There are bookings after this week"
        >
          <mat-icon>arrow_forward</mat-icon>
        </div>
        }
      </div>

      <!-- Upper grid for markers and days -->
      <mat-grid-list [cols]="8" [rowHeight]="32" class="upper-grid">
        <!-- TODAY marker row -->
        <mat-grid-tile [colspan]="1">
          <!-- Empty corner cell -->
        </mat-grid-tile>
        @for (pos of [0,1,2,3,4,5,6]; track pos) {
        <mat-grid-tile [colspan]="1">
          <div class="today-cell-container">
            @if (isToday(pos)) {
            <div class="today-marker">
              <span>TODAY</span>
            </div>
            }
          </div>
        </mat-grid-tile>
        }
      </mat-grid-list>

      <!-- Main grid for days and segments -->
      <mat-grid-list [cols]="8" [rowHeight]="110" class="appointment-grid">
        <!-- Day/date header row -->
        <mat-grid-tile [colspan]="1">
          <!-- Empty corner cell -->
        </mat-grid-tile>
        @for (pos of [0,1,2,3,4,5,6]; track pos) {
        <mat-grid-tile [colspan]="1">
          <div
            [class]="[
              isToday(pos) ? 'today-cell' : 'day-cell',
              isOverdueDay(pos) ? 'overdue-cell' : ''
            ]"
          >
            <h3 class="today-heading">{{ isOverdueDayString(pos) }}</h3>
            <h3 class="day-heading">{{ getDay(pos) }}</h3>
            {{ getDate(pos) }}
          </div>
        </mat-grid-tile>
        }

        <!-- Time segments rows -->
        @for (segment of segments; track segment) {
        <div>
          <mat-grid-tile [colspan]="1">
            <div class="day-cell segment-cell">
              <h3>{{ segment.description }}</h3>
              {{ startTimeString(segment) }} to
              {{ endTimeString(segment) }}
            </div>
          </mat-grid-tile>
          @for (pos of [0,1,2,3,4,5,6]; track pos) {
          <mat-grid-tile [colspan]="1">
            <div class="slot-container">
              <app-availability-info-display
                (click)="
                  selectSlot(segment, pos, slotObservables[segment.id][pos])
                "
                [calculating]="calculating && isSlotValid(pos, segment)"
                [info]="getObservable(pos, segment) | async"
                [loaderId]="'loader-' + segment.id + '-' + pos"
              ></app-availability-info-display>
              <!-- Show job reference inside the slot if there's a scheduled visit for this slot -->
              @if (getVisitCountForSlot(pos, segment) > 0) { @if
              (getVisitCountForSlot(pos, segment) === 1) {
              <div
                class="slot-visit-marker bottom-center"
                [matTooltip]="
                  'Job: ' +
                  getVisitForSlot(pos, segment).job?.externalJobReference +
                  ' - ' +
                  (getVisitForSlot(pos, segment).visitType?.description ||
                    'Visit') +
                  ' - Priority: ' +
                  getVisitForSlot(pos, segment).job?.priority?.description
                "
              >
                {{ getVisitForSlot(pos, segment).job?.externalJobReference }}
              </div>
              } @else {
              <div
                class="slot-visit-marker bottom-center"
                [matTooltip]="getVisitTooltipForMultipleVisits(pos, segment)"
              >
                {{ getVisitCountForSlot(pos, segment) }} bookings
              </div>
              } }
            </div>
          </mat-grid-tile>
          }
        </div>
        }
      </mat-grid-list>
    </div>
    @if (!exitOnCompletion || allowResourceLocking) {
    <div class="booking-right-sidebar">
      @if (visit) {
      <mat-list>
        <h3 mat-subheader>Schedules</h3>
        @for (schedule of visit.visitScheduleList; track schedule) {
        <mat-list-item>
          <mat-icon fontIcon="fa-wrench" fontSet="far" mat-list-icon></mat-icon>
          <h4 [matTooltip]="schedule.sorDescription" mat-line>
            {{ schedule.quantity }} x {{ schedule.sorDescription }}
          </h4>
          <p mat-line>
            SMV: {{ schedule.smv }} minutes Code: {{ schedule.sorCode }}
          </p>
        </mat-list-item>
        } @if (!visit.visitScheduleList || visit.visitScheduleList.length === 0)
        {
        <mat-list-item>No schedules </mat-list-item>
        }
      </mat-list>
      } @if (allowResourceLocking) {
      <div class="resource-list">
        <div class="resource-list-header">
          {{ resourceList?.length }} Resource{{
            resourceList?.length > 1 ? "s" : ""
          }}
          Required
        </div>
        @if (hasDuplicateResourceLocks()) {
        <div class="resource-duplicate-warning">
          <mat-icon>warning</mat-icon>
          <span>Resource '{{ getDuplicateResourceName() }}' is locked to multiple tickets</span>
        </div>
        }
        @for (resource of resourceList; track resource) {
        <div class="resource-list-item">
          <div class="resource-list-item-header">
            @if (this.resourceFormControl[resource.ticket.id]?.value?.imageUrl)
            {
            <img
              [src]="
                this.resourceFormControl[resource.ticket.id].value.imageUrl
              "
              alt="User Avatar"
            />
            }
            <h3>
              @if (this.resourceFormControl[resource.ticket.id].value) {
              {{ this.resourceFormControl[resource.ticket.id].value.name }}
              } @if (!this.resourceFormControl[resource.ticket.id].value) { Not
              locked }
            </h3>
          </div>
          <div class="resource-list-item-content">
            Skill Profile Required:
            {{ resource.ticket.skillProfile?.description ?? 'None' }}
          </div>
          <div class="resource-list-item-actions">
            <button
              (click)="selectResource(resource.ticket)"
              color="primary"
              mat-flat-button
            >
              Choose Resource
            </button>
            @if (resourceFormControl[resource.ticket.id].value !== null) {
            <button
              (click)="clearSelection(resource.ticket)"
              color="warn"
              mat-flat-button
            >
              Unlock
            </button>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
}
